import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {agentFinderAppBuilder} from './config/app-builder'

import {agentFinderRoute} from './routes/agent-finder-route'
import {agentDetailsRoute} from './routes/agent-details-route'
import {AgentFinder} from './routes/AgentFinder/AgentFinder'
import {AgentDetails} from './routes/AgentDetails/AgentDetails'

export const agentFinderApp = agentFinderAppBuilder.createDataRouterAppFromRoutes([
  agentFinderRoute.toRoute({Component: AgentFinder}),
  agentDetailsRoute.toRoute({Component: AgentDetails}),
])
registerDataRouterApp(agentFinderApp)
